module.exports = __webpack_public_path__ + "static/media/stofferingen-31.2cdea7af.jpg";